<div class="container mx-auto p-6 max-w-3xl">
  <h1 class="text-3xl font-bold mb-6 text-center">Adatvédelmi nyilatkozat</h1>

  <p class="mb-4 text-gray-700">
    Az alábbi tájékoztató célja, hogy ismertesse, hogyan kezeljük az Ön személyes adatait a kuponküldés és marketingkommunikáció során.
  </p>

  <section class="mb-6">
    <h2 class="text-xl font-semibold mb-2">1. Adatkezelő adatai</h2>
    <ul class="list-disc pl-6 text-gray-700">
      <li><strong>Név:</strong> Pekoli Diána Ildikó EV</li>
      <li><strong>Székhely:</strong> 1138 Budapest, Róbert Károly körút 18/A FSZ. 2.</li>
      <li><strong>E-mail:</strong> twogetherflower@gmail.com</li>
    </ul>
  </section>

  <section class="mb-6">
    <h2 class="text-xl font-semibold mb-2">2. Az adatkezelés célja</h2>
    <p class="text-gray-700 mb-2">
      Az Ön által megadott adatokat kizárólag az alábbi célokra használjuk fel:
    </p>
    <ul class="list-disc pl-6 text-gray-700">
      <li>Kupon és QR-kód kiküldése a feliratkozás után</li>
      <li>Opcionálisan marketing e-mailek küldése akciókról és újdonságokról</li>
    </ul>
  </section>

  <section class="mb-6">
    <h2 class="text-xl font-semibold mb-2">3. A kezelt adatok köre</h2>
    <ul class="list-disc pl-6 text-gray-700">
      <li>Név</li>
      <li>E-mail cím</li>
    </ul>
  </section>

  <section class="mb-6">
    <h2 class="text-xl font-semibold mb-2">4. Az adatkezelés jogalapja</h2>
    <ul class="list-disc pl-6 text-gray-700">
      <li>Kuponküldés: szerződés teljesítése (GDPR 6. cikk (1) b)</li>
      <li>Marketing e-mail: hozzájárulás (GDPR 6. cikk (1) a)</li>
    </ul>
  </section>

  <section class="mb-6">
    <h2 class="text-xl font-semibold mb-2">5. Az adatkezelés időtartama</h2>
    <p class="text-gray-700">
      Az adatokat a hozzájárulás visszavonásáig, de legfeljebb az utolsó aktivitást követő 2 évig őrizzük meg.
      A leiratkozás után az adataidat 30 napon belül töröljük.
    </p>
  </section>

  <section class="mb-6">
    <h2 class="text-xl font-semibold mb-2">6. Adattovábbítás</h2>
    <p class="text-gray-700">
      Az adatokat nem továbbítjuk harmadik félnek.
      Az e-mailek kiküldéséhez biztonságos, EU-n belüli adatfeldolgozót (pl. Google Firebase vagy Mailer szolgáltatás) használunk.
    </p>
  </section>

  <section class="mb-6">
    <h2 class="text-xl font-semibold mb-2">7. Az érintettek jogai</h2>
    <p class="text-gray-700 mb-2">Önt az alábbi jogok illetik meg:</p>
    <ul class="list-disc pl-6 text-gray-700">
      <li>hozzáférés az adataihoz</li>
      <li>helyesbítés, törlés kérése</li>
      <li>adatkezelés korlátozása</li>
      <li>hozzájárulás visszavonása</li>
      <li>panasz benyújtása a NAIH-nál</li>
    </ul>
  </section>

  <section class="mb-6">
    <h2 class="text-xl font-semibold mb-2">8. Kapcsolat</h2>
    <p class="text-gray-700">
      Ha bármilyen kérdésed van vagy szeretnéd visszavonni a hozzájárulásod,
      fordulj hozzánk bizalommal az alábbi elérhetőségen:
      <strong>twogetherflower@gmail.com</strong>
    </p>
  </section>

  <div class="text-center mt-8">
    <a routerLink="/" class="text-blue-600 underline hover:text-blue-800">
      ⬅ Vissza a főoldalra
    </a>
  </div>
</div>
